import { Zap, Snowflake } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-ink text-white border-t border-white/10 py-12" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <img src="/brand/jd-logo-full.png" alt="JD Electrical Ltd" className="h-14 w-auto" />
        <div className="flex items-center gap-6 font-body text-xs uppercase tracking-[0.15em] text-white/40">
          <span className="flex items-center gap-2"><Zap size={12} className="text-brand-yellow" /> Electrical</span>
          <span className="flex items-center gap-2"><Snowflake size={12} className="text-brand-blue" /> Air Con</span>
          <span>NAPIT · Gas Safe</span>
        </div>
        <p className="font-body text-xs text-white/40">© {new Date().getFullYear()} JD Electrical Ltd</p>
      </div>
    </footer>
  );
};
